/** Stable machine-readable reasons an edit can be rejected. */
export type EditErrorCode =
  | 'INVALID_COMMAND' // failed schema validation
  | 'ITEM_NOT_FOUND'
  | 'TRACK_NOT_FOUND'
  | 'TRACK_KIND_MISMATCH' // item type not allowed on target track
  | 'OVERLAP' // would overlap another item on a no-overlap track
  | 'OUT_OF_BOUNDS' // split/trim point outside the item
  | 'INVALID_SOURCE_RANGE' // sourceOut <= sourceIn
  | 'EMPTY_RESULT' // edit would produce a zero/negative-length item
  | 'NOT_ADJACENT'; // transition between non-adjacent items

/**
 * The single error type the reducer throws. Always carries which command op
 * failed, why (code), and — when applicable — which field was at fault, so the
 * agent self-repair loop and the UI can surface an actionable message.
 */
export class EditError extends Error {
  readonly code: EditErrorCode;
  readonly commandOp: string;
  readonly field?: string;

  constructor(code: EditErrorCode, message: string, commandOp: string, field?: string) {
    super(message);
    this.name = 'EditError';
    this.code = code;
    this.commandOp = commandOp;
    this.field = field;
  }
}
